<template>
    <div>
        
    </div>
</template>
<script>
export default {
    created () {
        this.$axios({
            method: "post",
            url: "api/alipays/pay", // 接口地址
            data: {
                totalMoney: this.$route.query.totalMoney
            }
        }).then(res => {
            console.log(res);   // 成功的返回     
            // this.queryDataRes = res.data;
            const div = document.createElement('div');
            div.innerHTML = res.data.resultData;
            document.body.appendChild(div);
            document.forms[0].submit();
            // this.$message.success('This is a success message');
            // this.openNotification({ bottomRight: 'bottomRight', state: 'success' });
        }).catch(error => {
            console.log(error);
            this.$message.error('This is an error message');
        }); // 失败的返回
        
    }
}
</script>
